class API {
  r;

  constructor(request) {
    this.r = request;
  }
}

export default API;
